import React from "react";
import WayfinderLayout from "./WayfinderLayout";
import AllLocationsTable from "./AllLocationsTable";

const AllLocationsManagerPage = ({ buttonColor }) => {
  return <AllLocationsTable buttonColor={buttonColor} />;
};

// Wrap with layout
const AllLocationsManagerPageWithLayout = () => (
  <WayfinderLayout>
    <AllLocationsManagerPage />
  </WayfinderLayout>
);

export default AllLocationsManagerPageWithLayout;
